import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";

const intervals = [
  { label: "Last 7 Days", value: "Last 7 Days" },
  { label: "Last 30 Days", value: "Last 30 Days" },
  { label: "Last 90 Days", value: "Last 90 Days" },
];

const TableComponent = ({
  dashboardStatsData,
  loading,
  monthsList,
  month1,
  setMonth1,
  month2,
  setMonth2,
  currentMonth,
  setCurrentMonth,
  weeklyDate,
  setWeeklyDate,
}) => {
  const monthWiseData = dashboardStatsData?.monthlyCollection || [];
  const weekWiseData = dashboardStatsData?.weeklyCollection || [];
  const [interval, setInterval] = useState("Last 7 Days");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const monthlyData = [
    {
      attribute: "Total Transactions",
      ...monthWiseData.reduce((acc, month) => {
        acc[month.name] = month.totalTransactions;
        return acc;
      }, {}),
    },
    {
      attribute: "Collection (PKR)",
      ...monthWiseData.reduce((acc, month) => {
        acc[month.name] = month.totalCollection;
        return acc;
      }, {}),
    },
  ];

  const weeklyData = [
    {
      attribute: "Total Transactions",
      ...weekWiseData.reduce((acc, day) => {
        acc[day.name] = day.totalTransactions;
        return acc;
      }, {}),
    },
    {
      attribute: "Collection (PKR)",
      ...weekWiseData.reduce((acc, day) => {
        acc[day.name] = day.totalCollection;
        return acc;
      }, {}),
    },
  ];

  return (
    <>
      <div className="my-2">
        <div className="filters-container mb-2">
          <h3 className="text-xl font-bold mb-0">Weekly Collection</h3>
          <div className="filters">
            {/* <Dropdown
              value={interval}
              options={intervals}
              onChange={(e) => setInterval(e.value)}
              placeholder="Select"
            />
            <Calendar
              value={fromDate}
              onChange={(e) => setFromDate(e.value)}
              placeholder="Select"
              showIcon
            /> */}
            {/* <Calendar
              value={toDate}
              onChange={(e) => setToDate(e.value)}
              placeholder="Select"
              showIcon
            /> */}

            <Calendar
              value={weeklyDate}
              onChange={(e) => setWeeklyDate(e.value)}
              showIcon
            />
          </div>
        </div>

        <DataTable scrollable value={weeklyData}>
          <Column field="attribute" header="Attribute" />
          {weekWiseData.map((day) => (
            <Column key={day.name} field={day.name} header={day.name} />
          ))}
        </DataTable>
      </div>

      <div className="my-2">
        <div className="filters-container mb-2">
          <h3 className="text-xl font-bold mb-0">Monthly Collection</h3>
          <div className="filters">
            <Dropdown
              value={month1}
              options={monthsList}
              onChange={(e) => setMonth1(e.value)}
              placeholder="Select Month 1"
              filter
            />
            <Dropdown
              value={month2}
              options={monthsList}
              onChange={(e) => setMonth2(e.value)}
              placeholder="Select Month 2"
              filter
            />
            <Dropdown
              value={currentMonth}
              options={monthsList}
              onChange={(e) => setCurrentMonth(e.value)}
              placeholder="Select Current Month"
              filter
            />
          </div>
        </div>

        <DataTable scrollable value={monthlyData}>
          <Column field="attribute" header="Attribute" />
          {monthWiseData.map((month) => (
            <Column key={month.name} field={month.name} header={month.name} />
          ))}
        </DataTable>
      </div>
    </>
  );
};

export default TableComponent;
